import React from 'react';

import { styleConfigs } from '../../resources/styleConfigs';

interface IConversationChatIconProps extends React.SVGProps<SVGSVGElement> {
  width?: string | number;
  height?: string | number;
  testId?: string;
}

const ConversationChatIcon = (props: IConversationChatIconProps): JSX.Element => {
  const {
    width = styleConfigs.dimensions.width20,
    height = styleConfigs.dimensions.height20,
    testId = 'conversation-chat-icon',
  } = props;

  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-testid={testId}
      width={width}
      height={height}
      viewBox="0 0 201 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_10842_23107)">
        <path
          d="M71.334 152.083L46.334 170.833V133.333H21.334C18.0188 133.333 14.8394 132.017 12.4951 129.672C10.1509 127.328 8.83398 124.149 8.83398 120.833V20.8335C8.83398 17.5183 10.1509 14.3389 12.4951 11.9947C14.8394 9.65046 18.0188 8.3335 21.334 8.3335H158.834C162.149 8.3335 165.329 9.65046 167.673 11.9947C170.017 14.3389 171.334 17.5183 171.334 20.8335V58.3335"
          stroke="currentColor"
          strokeWidth={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.334 45.8335H133.834"
          stroke="currentColor"
          strokeWidth={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.334 83.3335H71.334"
          stroke="currentColor"
          strokeWidth={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M196.334 158.333H171.334V195.833L133.834 158.333H96.334V83.3335H196.334V158.333Z"
          stroke="currentColor"
          strokeWidth={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M171.334 108.333H121.334"
          stroke="currentColor"
          strokeWidth={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M171.334 133.333H121.334"
          stroke="currentColor"
          strokeWidth={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10842_23107">
          <rect width={200} height={200} fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ConversationChatIcon;
